import * as Sentry from '@sentry/browser'
import getEnvironment from './getEnvironment'

/**
 * @param {string} sentryDsn unique to sentry "project"
 * @param {string} serverId (catalina property) to determine what env (dev/qa/prod)
 * @param {'true'|'false'} isDevelopmentServer (catalina property) if false this is prod
 * @return {void}
 */
export default function initializeSentry(
  sentryDsn, 
  serverId, 
  isDevelopmentServer, 
  beforeSend = (event) => event
) {
  try {
    const environment = getEnvironment({
      serverId,
      isDevelopmentServer: isDevelopmentServer === 'true'
    })
  
    Sentry.init({
      dsn: sentryDsn,
      environment,
      beforeSend
    })
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialise sentry!', err);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-js/utils/initializeSentry.js